module.exports = __webpack_public_path__ + "img/142.dbf23934.jpg";